module.exports = __webpack_public_path__ + "img/server-advert-phone-icon.27eaada4.svg";